import { faPlane } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Skeleton from 'react-loading-skeleton';

const DynamicFlightDetailsSkeleton = () => {
  return (
    <div className="default-shadow flight-details-item flight-details-flex">
      {' '}
      <div className="title-header-grey title">
        <Skeleton width={200} height={20} />
      </div>
      <div className="ticket ticket-dynamic">
        <div className="ticket-routes ticket-routes-borderless">
          {[...Array(2)].map((_, index) => (
            <div className="ticket-route" key={index}>
              <span className="ticket-airline">
                <Skeleton height={30} />
              </span>
              <div className="ticket-data">
                <div className="ticket-time">
                  <div className="ticket-time-inner">
                    <span className="date">
                      <Skeleton width={85} />
                    </span>
                    <span>
                      {' '}
                      <Skeleton width={90} />
                    </span>
                    <span className="city">
                      {' '}
                      <Skeleton width={70} />
                    </span>
                  </div>
                </div>
                <div className="ticket-directions">
                  <span className="stops-duration">
                    <Skeleton width={70} />
                  </span>
                  <span className="line">
                    <FontAwesomeIcon icon={faPlane} />
                    <span>
                      <Skeleton width={70} />
                    </span>
                  </span>
                </div>
                <div className="ticket-time">
                  <div className="ticket-time-inner">
                    <span className="date">
                      <Skeleton width={85} />
                    </span>
                    <span>
                      {' '}
                      <Skeleton width={90} />
                    </span>
                    <span className="city">
                      {' '}
                      <Skeleton width={70} />
                    </span>
                  </div>
                </div>
              </div>
              <div className="ticket-baggage">
                <Skeleton width={30} height={30} />
              </div>
            </div>
          ))}
        </div>
        <div className="ticket-price ">
          <div className="flex-center flex-one display-column">
            <Skeleton width={100} height={38} />
          </div>
        </div>
      </div>
      <div className="mt-30">
        <div className="title-underline text-lg mb-20">
          <Skeleton width={220} />
        </div>

        <div className="flex-table">
          <div className="flex-table-col names" style={{ flex: `0 0 25%` }}>
            <div className="flex-table-cell">
              <div className="text-bold text-st">
                <Skeleton width={120} />
              </div>
            </div>
            {[...Array(3)].map((_row, rowIndex) => (
              <div className="flex-table-cell" key={rowIndex}>
                <Skeleton width={120} />
              </div>
            ))}
            <div className="flex-table-cell"></div>
          </div>

          {[...Array(3)].map((_column, columnIndex) => (
            <div className={'flex-table-col'} style={{ flex: `0 0 25%` }} key={columnIndex}>
              <div className="flex-table-cell head text-bold">
                <Skeleton width={100} />
              </div>
              {[...Array(3)].map((_row, rowIndex) => (
                <div className="flex-table-cell" key={rowIndex}>
                  <Skeleton width={120} />
                </div>
              ))}
              <span className="flex-table-cell text-bold text-md">
                <Skeleton width={100} />
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DynamicFlightDetailsSkeleton;
